import { makeStyles, shorthands, tokens } from '@fluentui/react-components';

export const useTargetingStepStyles = makeStyles({
  root: {
    '& .unmapped-server-errors': {
      marginTop: '16px',
      marginBottom: '16px',
    },
  },
  collapseContainer: {
    maxWidth: '836px',
    ...shorthands.gap(tokens.spacingVerticalS),
  },
});
